import { Form, Row, Col, notification } from "antd";

import {
  LightBlueContainer,
  WhiteContainer,
} from "../../styled/Container.styled";
import { PrimaryButton } from "../../styled/Button.styled";
import Place from "./Place";
import { useAddPlaceMutation } from "../../../feature/PopularPlace/popularplaceApiSlice";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import appendData from "../../../utils/appendData";

const PopularPlaces_add = () => {
  const navigate = useNavigate();
  const [addPlace] = useAddPlaceMutation();
  const [imgFile, setImgFile] = useState("");
  const [imgStatus, setStatus] = useState<boolean>();
  return (
    <>
      <Form.Provider
        onFormFinish={(name, { forms }) => {
          if (name === "submitForm") {
            const { placeDetailsForm } = forms;
            placeDetailsForm.submit();
            let placeData = { ...placeDetailsForm.getFieldsValue() };
            const body: any = {
              placeName: placeData.placeName,
              place: placeData.place,
              address: placeData.address,
              district: placeData.district,
              state: placeData.state,
              image: imgFile,
              latitude: placeData.latitude,
              longitude: placeData.longitude,
              status: true
            };

            for (const key in body) {
              if (body[key] === undefined || body[key] === "") {
                notification.error({
                  message: "Fields are required!",
                  placement: "bottomLeft",
                });
                return;
              }
            }

            addPlace({ formData: body })
              .unwrap()
              .then(() => {
                notification.success({
                  message: "Successfully Added!",
                  placement: "bottomLeft",
                });
                navigate(-1);
              });
          }
        }}
      >
        <Row justify="end" gutter={20} className="button-bottom-margin">
          <Col>
            <Form name="submitForm">
              <PrimaryButton loading={imgStatus} htmlType="submit">Save</PrimaryButton>
            </Form>
          </Col>
        </Row>
        <LightBlueContainer>
          <WhiteContainer>
            <Place setImgFile={setImgFile} loading={(status: boolean) => setStatus(status)} />
          </WhiteContainer>
        </LightBlueContainer>
      </Form.Provider>
    </>
  );
};
export default PopularPlaces_add;
